<main class="container mt-5">
  <div class="row justify-content-lg-center">
    <div class="col-lg-8">
      <div class="card rounded holder">
        <div class="card-body">
          <h4 class="text-dark mb-3">Unblock your account</h4>
          <ng-container *ngIf="unblocked && !error">
            <alert type="success" class="mt-3">
              Your account <b>{{username}}</b> has been unblocked. You can now login.
            </alert>
          </ng-container>
          <ng-container *ngIf="!unblocked && error">
            <alert type="danger" class="mt-3">
              {{error}}
            </alert>
          </ng-container>
          <ng-container class="m-3 bg-light" *ngIf="!unblocked && !error">
            <span class="text-primary">
              <i class="fas fa-spinner fa-2x fa-spin"></i>
            </span> Unblocking account...
          </ng-container>
          <button type="button" class="btn btn-secondary float-end d-inline-block" [routerLink]="['/']">Go to login</button>
        </div>
      </div>
    </div>
  </div>
</main>

